// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var IdMaker$SmartcutsMacros = require("../../bs-utils/src/IdMaker.bs.js");
var OAuthProvider$SmartcutsMacros = require("./OAuthProvider.bs.js");

var include = IdMaker$SmartcutsMacros.Make({
      name: "OAuthCredentialId"
    });

var id_encode = include.id_encode;

var id_decode = include.id_decode;

function t_encode(encoder_oauthProviderCredential, v) {
  return Js_dict.fromArray([
              [
                "hostname",
                Decco.stringToJson(v.hostname)
              ],
              [
                "username",
                Decco.stringToJson(v.username)
              ],
              [
                "oauthProvider",
                OAuthProvider$SmartcutsMacros.t_encode(v.oauthProvider)
              ],
              [
                "oauthProviderCredential",
                Curry._1(encoder_oauthProviderCredential, v.oauthProviderCredential)
              ]
            ]);
}

function t_decode(decoder_oauthProviderCredential, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var hostname = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hostname"), null));
  if (hostname.TAG === /* Ok */0) {
    var username = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "username"), null));
    if (username.TAG === /* Ok */0) {
      var oauthProvider = OAuthProvider$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "oauthProvider"), null));
      if (oauthProvider.TAG === /* Ok */0) {
        var oauthProviderCredential = Curry._1(decoder_oauthProviderCredential, Belt_Option.getWithDefault(Js_dict.get(dict$1, "oauthProviderCredential"), null));
        if (oauthProviderCredential.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    hostname: hostname._0,
                    username: username._0,
                    oauthProvider: oauthProvider._0,
                    oauthProviderCredential: oauthProviderCredential._0
                  }
                };
        }
        var e = oauthProviderCredential._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".oauthProviderCredential" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = oauthProvider._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".oauthProvider" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = username._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".username" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = hostname._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".hostname" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function stringify(stringifyOAuthProviderCredential, param) {
  return "{hostname: " + (param.hostname + (", oauthProvider: " + (OAuthProvider$SmartcutsMacros.stringify(param.oauthProvider) + (", oauthProviderCredential: " + (Curry._1(stringifyOAuthProviderCredential, param.oauthProviderCredential) + "}")))));
}

var WithoutId = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(encoder_oauthProviderCredential, v) {
  return Js_dict.fromArray([
              [
                "id",
                Curry._1(id_encode, v.id)
              ],
              [
                "hostname",
                Decco.stringToJson(v.hostname)
              ],
              [
                "username",
                Decco.stringToJson(v.username)
              ],
              [
                "oauthProvider",
                OAuthProvider$SmartcutsMacros.t_encode(v.oauthProvider)
              ],
              [
                "oauthProviderCredential",
                Curry._1(encoder_oauthProviderCredential, v.oauthProviderCredential)
              ]
            ]);
}

function t_decode$1(decoder_oauthProviderCredential, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Curry._1(id_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var hostname = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hostname"), null));
    if (hostname.TAG === /* Ok */0) {
      var username = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "username"), null));
      if (username.TAG === /* Ok */0) {
        var oauthProvider = OAuthProvider$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "oauthProvider"), null));
        if (oauthProvider.TAG === /* Ok */0) {
          var oauthProviderCredential = Curry._1(decoder_oauthProviderCredential, Belt_Option.getWithDefault(Js_dict.get(dict$1, "oauthProviderCredential"), null));
          if (oauthProviderCredential.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      id: id._0,
                      hostname: hostname._0,
                      username: username._0,
                      oauthProvider: oauthProvider._0,
                      oauthProviderCredential: oauthProviderCredential._0
                    }
                  };
          }
          var e = oauthProviderCredential._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".oauthProviderCredential" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = oauthProvider._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".oauthProvider" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = username._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".username" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = hostname._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".hostname" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

var doesEqualStringId = include.doesEqualStringId;

var cmp = include.cmp;

exports.id_encode = id_encode;
exports.id_decode = id_decode;
exports.doesEqualStringId = doesEqualStringId;
exports.cmp = cmp;
exports.WithoutId = WithoutId;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
/* include Not a pure module */
